import React, { useState, useEffect } from 'react';
import React_Project from './React_Project';
import Android_Project from './Android_Project'; 
import AR_Project from './AR_Project';
const Project = () => {
  const [selectedSection, setSelectedSection] = useState('React');

  const handleNavItemClick = (section) => {
    setSelectedSection(section);
  };
  const renderProjectComponent = () => {
    switch (selectedSection) {
      case 'React':
        return <React_Project />;
      case 'Android':
        return <Android_Project />;
      case 'AR':
        return <AR_Project />;
      default:
        return null;
    }
  };

  return (
    <>
      <div className="parent-about">
        <h1>Project</h1>
        <div className="parent-project">
          <div className="nav-bar-project">
            <ul>
              <li><p onClick={() => handleNavItemClick('React')}>React</p></li>
              <li><p onClick={() => handleNavItemClick('Android')}>Android</p></li>
              <li><p onClick={() => handleNavItemClick('AR')}>AR</p></li>
            </ul>
          </div>
          <div className="child-project">
            {renderProjectComponent()}
          </div>
        </div>
      </div>
    </>
  );
};

export default Project;
